module.exports = __webpack_public_path__ + "boo.9f4af294.png";